
export default {
  components: {
    CreateAccount: () => import("@/components/createAccountNew1.vue")
  },
  head() {
    return {
      title: "Educational Worksheets with 7 day Free Trial | BrainGymJr",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Looking for an engaging and effective way to help your child excel beyond the classroom? Sign up for BrainGymJr customized program today! Our personalized approach to education beyond academics, combined with our 7-day free trial, makes learning fun and affordable. Sign up now!"
        }
      ]
    };
  },
  data() {
    return {
      pageLoaded: false,
      features: [
        {
          image: "1.webp",
          text: "Subscription for Maths, English and Real-World concepts."
        },
        {
          image: "2.webp",
          text: "Get customized daily exercises for your level."
        },
        {
          image: "3.webp",
          text: "Earn points for correct answers and top leaderboards"
        },
        {
          image: "4.webp",
          text:
            "Redeem Points for Discounts on Rewards like Toys, Games & Books"
        },
        {
          image: "5.webp",
          text:
            "16 fun formats including crosswords, sudoku, grid questions etc."
        },
        {
          image: "6.webp",
          text: "35,000+ practice questions with instant solutions."
        },
        {
          image: "7.webp",
          text: "Win badges and Earn Certificates for learning Milestones"
        },
        {
          image: "8.webp",
          text: "Comprehension style questions with audio stories"
        },
        {
          image: "9.webp",
          text: "Personalised Speed and Accuracy Dashboards"
        },
        {
          image: "10.webp",
          text:
            "Collect and Trade digital toys, avatars and pets with Friends and chat with them"
        }
      ],
      carouselSlide: 0
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xs;
    }
  }
};
